module.exports = __webpack_public_path__ + "img/c25.88270b2d.png";